// setup axios-cancel module
// allows auto cancel previous request by sending "requestId" in axios config
import axios from 'axios';
import axiosCancel from 'axios-cancel';
axiosCancel(axios);

// add csrf token to requests
axios.interceptors.request.use(config => {
  config.headers.csrfToken = window.__RequestVerificationToken;
  return config;
});